<template></template>

<script>
export default {
    props: {
        data: Object
    },

    mounted() {
        window.VWO = window.VWO || [];

        window.VWO.push(['track.revenueConversion', this.data.total_amount]);

        VWO.event =
            VWO.event ||
            function () {
                VWO.push(['event'].concat([].slice.call(arguments)));
            };

        VWO.event('sale', { sale: this.data.total_amount });
    }
};
</script>
